import React, {PureComponent, ReactNode} from "react"
import styled from "styled-components"

import noCardsLogo from "@irati/ui/images/saved-cards-empty.png"
import Card from "@irati/ui/src/Layout/Card"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"

import {StyledLabel1, Inner} from "./styled"

interface Props extends InjectIntl {
  text: string,
  useCardStyle?: boolean,
  children?: ReactNode
}

class NoData extends PureComponent<Props> {
  static defaultProps = {
    useCardStyle: false
  }

  render() {
    const idNamespace = id("no-data", this.props)
    const {useCardStyle, text, children, formatMessage} = this.props

    const Wrapper = useCardStyle ? Card : styled.div``

    return (
      <Wrapper id={idNamespace}>
        <Inner>
          <img src={noCardsLogo} alt={formatMessage({id: "wallet.noData.alt"})} />
          <StyledLabel1>{text}</StyledLabel1>
          {children}
        </Inner>
      </Wrapper>
    )
  }
}

export default injectIntl(NoData)
